export class FulfillmentRequest {
    constructor() {
        this.status = 'INITIALIZING';
    }
}
//# sourceMappingURL=fulfillmentRequest.js.map